import type { Discount } from '@api/discounts/types';
import type { Surcharge } from '@api/surcharges/types';

export type PriceModifierKind = 'discount' | 'surcharge';
export type PriceModifierRecord = Discount | Surcharge;

interface KindInfo {
  /** Lowercase noun for inline sentences ("View discount details"). */
  noun: string;
  /** Title-cased noun for sentence starts ("Discount created on..."). */
  title: string;
  /** URL path segment ("discounts", "surcharges"). */
  pluralPath: string;
}

export const KIND_INFO: Record<PriceModifierKind, KindInfo> = {
  discount: { noun: 'discount', title: 'Discount', pluralPath: 'discounts' },
  surcharge: { noun: 'surcharge', title: 'Surcharge', pluralPath: 'surcharges' },
};
